module.exports = __webpack_public_path__ + "img/thumb-005-21.a61ace73.png";